/* R7: one visit's campaign through links, dynamic quiz results, discounts and cart attributes.
   Only same-origin HTTP(S) URLs are decorated. An incoming campaign replaces the previous visit. */
(function () {
  'use strict';
  if (window.PlentumAttribution) return;
  var storageKey = 'plentum.attribution.v1';
  var campaign = Object.create(null), previousKeys = [], incoming = Object.create(null);
  var standardKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'gclid', 'fbclid', 'ttclid', 'msclkid'];
  function isKey(key) { return /^(utm_[a-z0-9_]+|gclid|fbclid|ttclid|msclkid)$/i.test(key); }
  function collect(params, target) {
    params.forEach(function (value, key) { if (isKey(key) && value) target[key.toLowerCase()] = value; });
  }
  try {
    var stored = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
    Object.keys(stored).forEach(function (key) { if (isKey(key) && typeof stored[key] === 'string') campaign[key] = stored[key]; });
  } catch (e) { /* links and in-memory attribution still work with storage blocked */ }
  previousKeys = Object.keys(campaign);
  collect(new URLSearchParams(location.search), incoming);
  if (Object.keys(incoming).length) campaign = incoming;
  try { sessionStorage.setItem(storageKey, JSON.stringify(campaign)); } catch (e) {}

  function decorate(href, depth) {
    if (!href || href.charAt(0) === '#') return href;
    try {
      var url = new URL(href, location.href);
      if (!/^https?:$/.test(url.protocol) || url.origin !== location.origin) return href;
      // An internal CTA's own UTMs must never overwrite the visitor's campaign.
      Array.from(url.searchParams.keys()).forEach(function (key) { if (isKey(key)) url.searchParams.delete(key); });
      Object.keys(campaign).forEach(function (key) { url.searchParams.set(key, campaign[key]); });
      if (/\/discount\//.test(url.pathname) && !depth && url.searchParams.has('redirect')) {
        url.searchParams.set('redirect', decorate(url.searchParams.get('redirect'), 1));
      }
      return url.pathname + url.search + url.hash;
    } catch (e) { return href; }
  }
  var pending, saved = false;
  function persist() {
    if (!Object.keys(campaign).length || saved) return Promise.resolve();
    if (pending) return pending;
    var attributes = {}, controller = new AbortController();
    // Empty values clear click IDs and campaign fields left on a cart by an earlier paid visit.
    standardKeys.concat(previousKeys, Object.keys(campaign)).forEach(function (key) { attributes[key] = campaign[key] || ''; });
    var timer = setTimeout(function () { controller.abort(); }, 2000);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    pending = fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }), signal: controller.signal, credentials: 'same-origin'
    }).then(function (response) { saved = response.ok; }).catch(function () {
      // A later checkout retries; the cart form also carries hidden attributes as a fallback.
    }).finally(function () { clearTimeout(timer); pending = null; });
    return pending;
  }
  function forms() {
    document.querySelectorAll('form[action]').forEach(function (form) {
      var action;
      try { action = new URL(form.action, location.href); } catch (e) { return; }
      if (action.origin !== location.origin || !/\/(cart|checkout)\/?$/.test(action.pathname)) return;
      standardKeys.concat(previousKeys, Object.keys(campaign)).forEach(function (key) {
        if (!Object.keys(campaign).length) return;
        var name = 'attributes[' + key + ']';
        var input = Array.from(form.elements).find(function (el) { return el.name === name; });
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
        if (input.value !== (campaign[key] || '')) input.value = campaign[key] || '';
      });
    });
  }
  function links() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var before = link.getAttribute('href'), after = decorate(before);
      if (before !== after) link.setAttribute('href', after);
    });
    forms();
  }
  window.PlentumAttribution = { decorate: decorate, persist: persist };
  var resume = false;
  function isCheckout(url) {
    try { var u = new URL(url, location.href); return u.origin === location.origin && /\/(checkout|checkouts)(\/|$)|\/cart\/\d+:/.test(u.pathname); }
    catch (e) { return false; }
  }
  document.addEventListener('click', function (event) {
    var a = event.target.closest && event.target.closest('a[href]');
    if (!a) return;
    a.setAttribute('href', decorate(a.getAttribute('href')));
    if (resume || !isCheckout(a.href) || !Object.keys(campaign).length || saved || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var href = a.href, target = a.target, rel = a.rel;
    persist().then(function () {
      var link = a;
      if (!link.isConnected) {
        link = document.createElement('a'); link.href = href; link.target = target; link.rel = rel;
        link.hidden = true; document.body.appendChild(link);
      }
      resume = true;
      try { link.click(); } finally { resume = false; if (link !== a) link.remove(); }
    });
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target, submitter = event.submitter;
    var action = (submitter && submitter.getAttribute('formaction')) || form.action;
    if (resume || !(isCheckout(action) || (submitter && submitter.name === 'checkout')) || !Object.keys(campaign).length) return;
    forms();
    if (saved) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var formId = form.id, buttonId = submitter && submitter.id;
    var buttonName = submitter && submitter.name, buttonValue = submitter && submitter.value;
    persist().then(function () {
      // Shopify replaces drawer markup after cart updates. Resolve current nodes after the save.
      var currentForm = form.isConnected ? form : (formId && document.getElementById(formId));
      if (!currentForm || currentForm.tagName !== 'FORM') {
        currentForm = document.createElement('form'); currentForm.action = action;
        currentForm.method = form.method; currentForm.target = form.target; currentForm.hidden = true;
        document.body.appendChild(currentForm);
      }
      var button = submitter && submitter.isConnected && submitter.form === currentForm ? submitter : (buttonId && document.getElementById(buttonId));
      if (!button || button.form !== currentForm) {
        button = Array.from(currentForm.elements).find(function (el) { return el.name === buttonName && el.type === 'submit'; });
      }
      if (!button && submitter) {
        button = document.createElement('button'); button.type = 'submit'; button.name = buttonName;
        button.value = buttonValue; button.hidden = true; currentForm.appendChild(button);
      }
      forms();
      resume = true;
      try { currentForm.requestSubmit(button || undefined); } finally { resume = false; }
    });
  }, true);
  function init() {
    links(); persist();
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(function () { scheduled = false; links(); });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'action'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
